module.exports = __webpack_public_path__ + "img/index_reward_third.414e270e.png";